import { render, staticRenderFns } from "./TwoFactorAuthSetup.vue?vue&type=template&id=c91f2b64&scoped=true&"
import script from "./TwoFactorAuthSetup.vue?vue&type=script&lang=js&"
export * from "./TwoFactorAuthSetup.vue?vue&type=script&lang=js&"
import style0 from "./TwoFactorAuthSetup.vue?vue&type=style&index=0&id=c91f2b64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c91f2b64",
  null
  
)

export default component.exports